import React, { useEffect } from 'react'

import {
    Card,
    Typography,
    List,
    ListItem,
    ListItemPrefix,
    Accordion,
    AccordionHeader,
    AccordionBody
} from '@material-tailwind/react'
import { Link, usePage } from '@inertiajs/react'

import { FaAngleRight, FaChevronDown, FaBed, FaUsers } from 'react-icons/fa6'
import { HiPresentationChartBar } from 'react-icons/hi'
import { CiPower } from 'react-icons/ci'
import { FaListAlt } from 'react-icons/fa'
import { BsBox } from 'react-icons/bs'
import { PiUserSwitchFill } from 'react-icons/pi'
import { LuBuilding2 } from 'react-icons/lu'

export default function SidebarWithLogo({ className }) {
    const { auth } = usePage().props

    const [open, setOpen] = React.useState(0)

    const handleOpen = value => {
        setOpen(() => {
            const op = open === value ? 0 : value
            localStorage.setItem('current-open', String(op))
            return op
        })
    }

    useEffect(() => {
        const currentOpen = localStorage.getItem('current-open')

        if (currentOpen) {
            setOpen(Number(currentOpen))
        }
    }, [])

    return (
        <Card className={className}>
            <List>
                <Link href={route('dashboard')}>
                    <ListItem
                        selected={route().current('dashboard' + '*')}
                        onClick={() => setOpen(0)}
                    >
                        <ListItemPrefix>
                            <HiPresentationChartBar className="h-5 w-5" />
                        </ListItemPrefix>
                        Dashboard
                    </ListItem>
                </Link>

                {auth.user.role === '1' && (
                    <Link href={route('hospitals')}>
                        <ListItem
                            selected={route().current('hospitals' + '*')}
                            onClick={() => setOpen(0)}
                        >
                            <ListItemPrefix>
                                <LuBuilding2 className="h-5 w-5" />
                            </ListItemPrefix>
                            Hospitals
                        </ListItem>
                    </Link>
                )}

                <Link href={route('users')}>
                    <ListItem
                        selected={route().current('users' + '*')}
                        onClick={() => setOpen(0)}
                    >
                        <ListItemPrefix>
                            <FaUsers className="h-5 w-5" />
                        </ListItemPrefix>
                        Users
                    </ListItem>
                </Link>

                <hr className="my-2 border-blue-gray-50" />

                <Link href={route('consumable-description.janitorial')}>
                    <ListItem
                        onClick={() => setOpen(0)}
                        selected={route().current('consumable-description.janitorial' + '*')}
                    >
                        <ListItemPrefix>
                            <FaListAlt className="h-5 w-5" />
                        </ListItemPrefix>
                        Consumable Item Description
                    </ListItem>
                </Link>

                <Link href={route('consumable.janitorial')}>
                    <ListItem
                        onClick={() => setOpen(0)}
                        selected={route().current('consumable.janitorial' + '*')}
                    >
                        <ListItemPrefix>
                            <BsBox className="h-5 w-5" />
                        </ListItemPrefix>
                        Consumable Items
                    </ListItem>
                </Link>

                <Accordion
                    open={open === 2}
                    icon={
                        <FaChevronDown
                            strokeWidth={2.5}
                            className={`mx-auto h-4 w-4 transition-transform ${open === 2 ? 'rotate-180' : ''}`}
                        />
                    }
                >
                    <ListItem className="p-0" selected={open === 2}>
                        <AccordionHeader
                            onClick={() => handleOpen(2)}
                            className="border-b-0 p-3"
                        >
                            <ListItemPrefix>
                                <PiUserSwitchFill className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography color="blue-gray" className="mr-auto font-normal">
                                HR
                            </Typography>
                        </AccordionHeader>
                    </ListItem>
                    <AccordionBody className="py-1">
                        <List className="p-0">
                            <Link href={route('hr.janitorial')}>
                                <ListItem selected={route().current('hr.janitorial' + '*')}>
                                    <ListItemPrefix>
                                        <FaAngleRight strokeWidth={3} className="h-3 w-5" />
                                    </ListItemPrefix>
                                    Janitorial
                                </ListItem>
                            </Link>

                            <Link href={route('hr.security')}>
                                <ListItem selected={route().current('hr.security' + '*')}>
                                    <ListItemPrefix>
                                        <FaAngleRight strokeWidth={3} className="h-3 w-5" />
                                    </ListItemPrefix>
                                    Security
                                </ListItem>
                            </Link>

                            <Link href={route('hr.mepg')}>
                                <ListItem selected={route().current('hr.mepg' + '*')}>
                                    <ListItemPrefix>
                                        <FaAngleRight strokeWidth={3} className="h-3 w-5" />
                                    </ListItemPrefix>
                                    MEPG
                                </ListItem>
                            </Link>

                            <Link href={route('hr.ct-scan')}>
                                <ListItem selected={route().current('hr.ct-scan' + '*')}>
                                    <ListItemPrefix>
                                        <FaAngleRight strokeWidth={3} className="h-3 w-5" />
                                    </ListItemPrefix>
                                    CT-Scan
                                </ListItem>
                            </Link>
                        </List>
                    </AccordionBody>
                </Accordion>

                <Link href={route('logout')} method="post" as="button">
                    <ListItem className="mb-8">
                        <ListItemPrefix>
                            <CiPower className="h-5 w-5" />
                        </ListItemPrefix>
                        Log Out
                    </ListItem>
                </Link>
            </List>
        </Card>
    )
}
